import React from "react";
import { Routes, Route, useMatch, Navigate } from "react-router-dom";
import { CarteirasAbertas } from "../../../pages";
const AberturaRoutes = () => {
  let { path } = useMatch();
  return (
    <Routes>
      <Route exact path={path} component={CarteirasAbertas} />
      <Navigate to="/dashboard" />
    </Routes>
  );
};

export default AberturaRoutes;
